import GUI from 'lil-gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { gsap } from 'gsap'




const gui = new GUI()
gui.hide(); 

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()


const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1,)
const overlayMaterial = new THREE.ShaderMaterial
({
    transparent: true,
    uniforms:
    {
        uAlpha: { value: 1 }
    },
    vertexShader: `
        void main()
        {
            gl_Position = vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform float uAlpha;
        void main()
        {
            gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
        }
    `
})


const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
scene.add(overlay)

/**
 * Loaders
 */
let scenenot = false
const loadingBarElement = document.querySelector('.loading-bar',)
const loadingManager = new THREE.LoadingManager(
    // Loaded
    () => {


        window.setTimeout(() => {
            gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0, delay: 1 })

            loadingBarElement.classList.add('ended')
            loadingBarElement.style.transform = ''
        }, 500)

        window.setTimeout(() =>
        {
            scenenot = true
        }, 2000)

    
    },

    // Progress
    (itemUrl, itemsLoaded, itemsTotal) => {
        const progressRatio = itemsLoaded / itemsTotal
        loadingBarElement.style.transform = `scaleX(${progressRatio})`
    }
)
const textureLoader = new THREE.TextureLoader(loadingManager)

// Draco loader
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('./draco/')

// GLTF loader
const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)

/**
 * Object
 */





const bakedTexture = textureLoader.load("baked.jpg",)
bakedTexture.flipY = false
bakedTexture.colorSpace = THREE.SRGBColorSpace

const bakedTexture1 = textureLoader.load("baked2.jpg",)
bakedTexture1.flipY = false
bakedTexture1.colorSpace = THREE.SRGBColorSpace


const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture })

const bakedMaterial1 = new THREE.MeshBasicMaterial({ map: bakedTexture1 })

gltfLoader.load(
    "baked.glb",
    (gltf) => {
        gltf.scene.traverse((child) => {
            child.material = bakedMaterial

        }

        )
        scene.add(gltf.scene)
    }
)

gltfLoader.load(
    "baked2.glb",
    (gltf) => {
        gltf.scene.traverse((child) => {
            child.material = bakedMaterial1

        }

        )
        scene.add(gltf.scene)
    }
)

const raycaster = new THREE.Raycaster()


const points = [
    {
        position: new THREE.Vector3(6.5, -3.8, -1),
        element: document.querySelector('.point-0')

    },
    {
        position: new THREE.Vector3(6.5, -3.8, 13),
        element: document.querySelector('.point-1')

    },
    {
        position: new THREE.Vector3(2, -3.8, 17),
        element: document.querySelector('.point-2')

    },
    {
        position: new THREE.Vector3(0, -3.8, -3),
        element: document.querySelector('.point-3')

    },
    {
        position: new THREE.Vector3(-10, -3.8, 13),
        element: document.querySelector('.point-4')

    },
    {
        position: new THREE.Vector3(3, -3.8, -3),
        element: document.querySelector('.point-5')

    },

    {
        position: new THREE.Vector3(2, -1, -3),
        element: document.querySelector('.point-6')

    },
    {
        position: new THREE.Vector3(-4.5, 1, 4),
        element: document.querySelector('.point-7')

    },

    {
        position: new THREE.Vector3(1, 4, 4),
        element: document.querySelector('.point-8')

    },

    {
        position: new THREE.Vector3(-9, -3, -2),
        element: document.querySelector('.point-9')

    },

    {
        position: new THREE.Vector3(-3.5, -3.8, -3),
        element: document.querySelector('.point-10')

    },


    
     

    
 
]


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})


/**
 * Camera
 */
// Base camera

const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(1, 4, -25)
scene.add(camera)
// Controls
const controls = new OrbitControls(camera, canvas)
const isMobile = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
if (isMobile) {
    // Mobile settings: faster, possibly lower damping
    controls.rotateSpeed = 0.5;
    controls.zoomSpeed = 0.8;
    controls.enablePan = false; // Often better to disable pan on small screens
    controls.enableDamping = false; // Improves performance on some mobile browsers
    controls.minDistance = 20;
} else {
    // Desktop settings
    controls.enableDamping = true;
    controls.dampingFactor = 0.05;
    controls.rotateSpeed = 1.0;
    controls.zoomSpeed = 1.0;
    controls.enablePan = true;
}



controls.enableDamping = true
controls.minDistance = 14;
controls.maxDistance = 45;

controls.maxPolarAngle = Math.PI / 2;
controls.visible = false;
/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor( "rgb(43,158,179)")

const ambientLight = new THREE.AmbientLight(0xffffff, 8)
scene.add(ambientLight)





/**
 * Animate
 */


const tick = () => {

    // Update controls
    controls.update()

    if(scenenot) {
        for (const point of points) {
            const screenPosition = point.position.clone()
            screenPosition.project(camera)

            raycaster.setFromCamera(screenPosition, camera)
            const intersects = raycaster.intersectObjects(scene.children, true)

            if (intersects.length === 0) {
                point.element.classList.add('visible')
            }
            else {
                const intersectionDistance = intersects[0].distance
                const pointDistance = point.position.distanceTo(camera.position)

                if (intersectionDistance < pointDistance) {
                    point.element.classList.remove('visible')
                }
                else {
                    point.element.classList.add('visible')
                }
            }

            const translateX = screenPosition.x * sizes.width * 0.5
            const translateY = - screenPosition.y * sizes.height * 0.5
            point.element.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`

        }
    }


    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

